/**
 * Created by pmnia on 12/03/15.
 */
(function () {
    'use strict';

    angular
        .module('app.login')
        .directive('obtLogin', obtLogin);

    function obtLogin () {
        var directive = {
            //link: link,
//            transclude:true,
            controller:obtLoginCtlr,
            controllerAs:'vmLogin',
            restrict:'EA',
            replace:true,
            template:'<li class="tasks-menu">\n    <button ng-if="!vmLogin.isLogged()" href="" ng-click="signIn()" class="navbar-btn btn btn-secondary-outline" >{{\'SIGN_IN\'|translate}}</button>\n    <button ng-if="vmLogin.isLogged()" href="#" class="navbar-btn btn btn-secondary-outline dropdown-toggle" data-toggle="dropdown">{{vmLogin.userName()}}<span class="caret"></span></button>\n    <ul ng-if="vmLogin.isLogged()" class="dropdown-menu" role="menu">\n        <li>\n            <ul class="menu">\n                <li><a href ng-click="vmLogin.openPreference()"><h3>{{\'PREFERENCE\'|translate}}</h3></a></li>\n                <li><a href ng-click="vmLogin.openHistory()"><h3>{{\'HISTORY\'|translate}}</h3></a></li>\n                <li ng-if="vmLogin.isReseller()"><a  href ng-click="vmLogin.openResellerReport()"><h3>{{\'RESELLER_REPORT\'|translate}}</h3></a></li>\n                <!--<li class="divider"></li>-->\n                <li><a href ng-click="vmLogin.signOut()"><h3>{{\'LOG_OUT\' | translate}}</h3></a></li>\n            </ul>\n        </li>\n    </ul>\n    <obt-modal-popup\n            title=\'login\'\n            open-modal-promise=\'signIn\'\n            template-url=\'app/login/signIn.html\'\n            template-controller=\'LoginController as vmLogin\'>\n    </obt-modal-popup>\n</li>'
        };
        return directive;
    }

    //obtLoginCtlr.$inject=['loginServices', '$state', '$stateParams', 'logger'];
    /*@ngInject*/
    function obtLoginCtlr(loginServices, $state, $stateParams, logger){
        var vm = this;
        vm.session = loginServices;
        vm.isLogged = isLogged;
        vm.isReseller = isReseller;
        vm.signOut = signOut;
        vm.userName = getUserName;
        vm.openPreference = openPreference;
        vm.openHistory = openHistory;
        vm.openResellerReport = openResellerReport;

        function openResellerReport(){
            if(isLogged() && isReseller()) {
                var params = {
                    uId: loginServices.status.uId,
                    cId: $stateParams.cId,
                    tId: $stateParams.tId
                };
                var resellerState = $state.current.resellerState ? $state.current.resellerState : 'resellerBookingReport';

                $state.go(resellerState, params);
            }else{
                logger.info('user not logged');
            }
        }

        function openPreference(){

            if(isLogged()) {
                var params = {
                    uId: loginServices.status.uId,
                    cId: $stateParams.cId,
                    tId: $stateParams.tId
                };
                var preferenceState = $state.current.preferenceState ? $state.current.preferenceState : 'preference';

                $state.go(preferenceState, params);
            }else{
                logger.info('user not logged');
            }
        }

        function openHistory(){

            if(isLogged()) {
                var params = {
                    uId: loginServices.status.uId,
                    cId: $stateParams.cId,
                    tId: $stateParams.tId
                };
                var historyState = $state.current.historyState ? $state.current.historyState : 'history';

                $state.go(historyState, params);
            }else{
                logger.info('user not logged');
            }
        }
        function getUserName (){
            return loginServices.status ? loginServices.status.fName + ' ' + loginServices.status.lName  : "";
        }
        function isLogged(){
            return loginServices.status && loginServices.status.isLogged;
        }
        function isReseller(){
            return loginServices.status && loginServices.status.reseller;
        }
        function signOut(){
            loginServices.signOut().then(function(){
                // Redirect to selected page, or stay on the same page
                var logoutState = $state.current.logoutState;
                if(logoutState){
                    $state.go(logoutState, $stateParams, {reload:true});
                }
            });
        }
    }
    //function link(scope, element, attrs) {
    //}
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/login/obt-Login.directive.js
 ** module id = 228
 ** module chunks = 0
 **/